import React, { useState, useEffect } from "react";
import { Modal, ModalBody, Form, Row, Col } from "reactstrap";
import StyledButton from "../../components/Common/StyledButton";
import * as Yup from "yup";
import { createEditTaxIdentity, deleteTaxIdentity } from "../../api";

const GstPanModal = ({ clientId, openModal, setOpenModal, editId = null, values, updateTaxIdentity, notify }) => {
  const [fieldType, setFieldType] = useState(""); // 'GST' or 'PAN'
  const [fieldValue, setFieldValue] = useState("");
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  // Populate modal fields if editing
  useEffect(() => {
    if (editId) {
        setFieldType(values.fieldType);
        setFieldValue(values.fieldValue);
    } else {
      setFieldType("");
      setFieldValue("");
    }
  }, [openModal, editId, values]);

  const createOrEditGSTPAN = async () => {
    setIsButtonLoading(true);
    const response = await createEditTaxIdentity({
      clientId,
      _id: editId,
      taxType: fieldType,
      taxRegistrationNumber: fieldValue,
    });
    if (response.success) {
      const taxIdentity = response.payload.taxIdentity;
      notify("success", response.message);
      updateTaxIdentity(taxIdentity);
      setIsButtonLoading(false);
      setOpenModal(false);
    } else {
       notify("Error", response.message);
       setIsButtonLoading(false);
       setOpenModal(false);
    }
  }

  const validateTaxValue = (type, value, strict = false) => {
    if (type === "GST") {
      const partial = /^[0-9A-Z]{0,15}$/;
      const full = /^[0-9A-Z]{15}$/;
      return strict ? value && full.test(value) : partial.test(value);
    }
  
    if (type === "PAN") {
      const partial = /^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/;
      const full = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      return strict ? value && full.test(value) : partial.test(value);
    }
  
    return strict ? type && value : true;
  };

  const checkFieldChanged = () => {
    if (editId) {
        return fieldType === values.fieldType && fieldValue === values.fieldValue;
    }
    return false;
  };

  const onDeleteTaxIdentity = async () => {
    const response = await deleteTaxIdentity(editId);
    if (response.success) {
      notify("success", response.message);
      updateTaxIdentity({_id: editId }, true);
      setOpenModal(false);
    } else {
       notify("Error", response.message);
       setOpenModal(false);
    }
  };

  return (
    <Modal
      size="md"
      centered
      isOpen={openModal}
      toggle={() => setOpenModal(false)}
    >
        <div className="modal-header">
          <h4>{editId ? "Edit GST/PAN" : "Add GST/PAN"}</h4>
          <StyledButton outline color="danger" onClick={() => setOpenModal(false)}>
            Close
          </StyledButton>
        </div>

        <ModalBody>
          <Row>
            <Col className="mt-2">
              <label className="item-name">Select Type</label>
              <select
                className="form-select"
                value={fieldType}
                onChange={(e) => {
                  const val = e.target.value;
                  setFieldType(val);
                  if (!val) {
                    setFieldValue('');
                  }
                }}
              >
                <option value="">Select Type</option>
                <option value="GST">GST</option>
                <option value="PAN">PAN</option>
              </select>
            </Col>
          </Row>

          <Row>
            <Col className="mt-3">
              <label className="item-name">Enter Value</label>
              <input
                type="text"
                className="form-control"
                placeholder={fieldType ? (fieldType === "GST" ? "Enter GST Number" : "Enter PAN Number") : ''}
                value={fieldValue}
                disabled={!fieldType}
                onChange={(e) => {
                  const val = e.target.value.toUpperCase();
                  setFieldValue(val);
                }}
              />
              <small className="text-danger">
              {fieldType === "GST" && !validateTaxValue(fieldType, fieldValue) && (
                'Invalid GST Number'
              )}

              {fieldType === "PAN" && !validateTaxValue(fieldType, fieldValue) && (
                'Invalid PAN Number'
              )}
              </small>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <StyledButton
                color={"primary"}
                className={"w-md mx-2"}
                onClick={createOrEditGSTPAN}
                isLoading={isButtonLoading}
                disabled={!validateTaxValue(fieldType, fieldValue, true) || checkFieldChanged()}
              >
                {editId ? "Update" : "Save"}
              </StyledButton>
              {editId && (
                <StyledButton
                  color="danger"
                  className={"w-md mx-2"}
                  onClick={onDeleteTaxIdentity}
                  isLoading={isButtonLoading}
                >
                  Delete
                </StyledButton>
                )}
            </Col>
          </Row>
        </ModalBody>
    </Modal>
  );
};

export default GstPanModal;